import { useState } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import { RecentUpdate, ViewedUpdates } from "../../../../../Constants/Constants";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import UserStatus from "./UserStatus";

const ContactStatus = () => {
  const [open, setOpen] = useState("1");
  const toggle = (id: string) => setOpen(open === id ? "" : id);
  const { contactStatusActive } = useAppSelector((state) => state.mainSidebar);

  return (
    <div className="contact-status-box">
      <div className="template-title border-0">
        <h3>{RecentUpdate}</h3>
      </div>
      {contactStatusActive
        .filter((item) => !item.status)
        .map((item, index) => (
          <UserStatus key={index} item={item} />
        ))}
      <Accordion open={open} toggle={toggle}>
        <AccordionItem>
          <AccordionHeader targetId="1">{ViewedUpdates}</AccordionHeader>
          <AccordionBody accordionId="1" className="accordion-collapse collapse">
            {contactStatusActive
              .filter((item) => item.status)
              .map((item, index) => (
                <UserStatus key={index} item={item} />
              ))}
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default ContactStatus;
